export interface ToolkitItem {
  id: string;
  altName: string;
  icon: string;
  activeIcon: string;
  tooltiptext: string;
  panelComponent?: string; // Component to render in the panel
  route?: string; // For navigation instead of panel
  panelWidth?: number; // Custom panel width (default: 400)
  openByDefault?: boolean; // If true, this panel will open automatically on layout load
  expandByDefault?: boolean; // If true, this panel will open in full-width mode by default
}

export const toolKitList: ToolkitItem[] = [
  // Copilot icon hidden — uncomment to bring back the right-sidebar entry.
  // {
  //   id: 'copilot',
  //   altName: 'copilot',
  //   icon: '../../../assets/icons/sidebar/star-ai.svg',
  //   activeIcon: '../../../assets/icons/sidebar/star-active.svg',
  //   tooltiptext: 'Ask Copilot',
  //   panelComponent: 'copilot',
  //   panelWidth: 350,
  //   openByDefault: false,
  //   expandByDefault: true // Set to true to open in full-width mode by default
  // },
  {
    id: 'report',
    altName: 'report',
    icon: '../../../assets/icons/sidebar/report.svg',
    activeIcon: '../../../assets/icons/sidebar/report-active.svg',
    tooltiptext: 'View Report',
    route: '/reports'
  }
];
